import React from "react";

function CommandHeader({ command }) {
    return (
        <p className="font-mono text-sm text-muted-foreground">
            <span className="text-primary">mauricio@denver</span>
            <span>:~$ </span>
            {command}
            <span
                className="ml-1 inline-block h-3.5 w-2 translate-y-0.5 animate-pulse bg-primary"
                aria-hidden="true"
            />
        </p>
    );
}

export default CommandHeader;
